module.exports = __webpack_public_path__ + "static/media/provider_airtel.def1b38d.png";